import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setNav(true);
      } else {
        setNav(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`py-4 mx-auto ${nav ? "fixed top-0 left-0 w-full" : ""}`}>
      <ul className="hidden md:flex w-full bg-gray-400/20 h-12 backdrop-blur-2xl rounded-full max-w-[400px] mx-auto justify-between items-center px-5 text-gray-400">
        <li className="p-2">
          <Link
            to="main"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
            activeClassName="selected"
            className="nav-link"
          >
            Home
          </Link>
        </li>
        <li className="p-2">
          <Link
            to="about"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
            activeClassName="selected"
            className="nav-link"
          >
            About
          </Link>
        </li>
        <li className="p-2">
          <Link
            to="portfolio"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
            activeClassName="selected"
            className="nav-link"
          >
            Portfolio
          </Link>
        </li>
        <li className="p-2">
          <Link
            to="contact"
            spy={true}
            smooth={true}
            offset={50}
            duration={500}
            activeClassName="selected"
            className="nav-link"
          >
            Contact
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
